export const defaultProduct = {
  nameFr: "",
  nameEn: "",
  descriptionFr: "",
  descriptionEn: "",
  category: "",
  brand: "",
  imageUrl: "",
  price: "",
  priceTypeId: 0,
  isVisible: false,
  productNumber: "",
  location: {
    formattedAddress: "",
    latitude: 0,
    longitude: 0,
    regionId: 0,
  },
  availabilities: [],
  restrictions: {
    maxHoursPerDay: null,
    allowedDays: [],
  },
  productConfigurations: [],
  showAddress: false,
  productInventoryLimits: {
    inventoryMode: "unlimited", // exemple : "stock", "hourly", etc.
    totalQuantity: 0,
    maxDuration: 0, // in hours
    returnPolicy: "none",
  },
};
